import { CatalogStateService } from "@app/catalog";
import { Messenger } from "@app/shared";

export class RoomPropertyStateHandler {
  private messenger: Messenger;

  public initialize( catalogStateService: CatalogStateService,
      messenger: Messenger,) {
    this.messenger = messenger;

  }

}
